import { render, staticRenderFns } from "./cart-drawer-line-item.vue?vue&type=template&id=28584ea8&"
import script from "./cart-drawer-line-item.vue?vue&type=script&lang=js&"
export * from "./cart-drawer-line-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports